import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    name: '',
    role: '',
    currentDevice: [],
    devicePage: 1,
    devicePageTotal: 1
  },
  getters: {
    userName(state){
      return state.name
    },
    getCurrentDevice(state){
      return state.currentDevice
    },
    getDevicePage(state){
      return state.devicePage
    },
    getDeviceTotalPage(state){
      return state.devicePageTotal
    }
  },
  mutations: {
    setUserName(state,name){
      state.name = name
    },
    setUserRole(state,role){
      state.role = role
    },
    setCurrentDevice(state, devices){
      state.currentDevice = devices
    },
    setDevicePage(state, page){
      state.devicePage = page
    },
    setDeviceTotalPage(state, totalPage){
      state.devicePageTotal = totalPage
    }
  },
  actions: {
  },
  modules: {
  }
})
